<script>
// import axios from 'axios'
export default {
  props: {
    colorProp: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      colors: {
        '#EB4D82': 'Cherry',
        '#DD5DAA': 'Rose',
        '#C072E3': 'Lavender',
        '#AA5FDC': 'Amethyst',
        '#9358E9': 'Grape',
        '#644DD6': 'Purple',
        '#4B61EE': 'Cobalt', //primary
        '#3DBEFF': 'Blue',
        '#09D3E0': 'Turquoise',
        '#09D6B7': 'Cyan',
        '#10CF84': 'Lime',
        '#1FCC3F': 'Malachite',
        '#5BCA11': 'Green',
        '#7EC710': 'Pistachio',
        '#ABC900': 'Avocado',
        '#D9CA2B': 'Citron',
        '#FEBD00': 'Banana',
        '#FE992E': 'Mango',
        '#FF7142': 'Pumpkin',
        '#FF5467': 'Tomato',
      },
      colorHex: '#4B61EE',
    }
  },
  computed: {
    colorName() {
      return this.colors[this.colorHex]
    },
  },
  created() {
    this.colorHex = this.randomColor()
    if (this.colorProp != null) {
      this.colorHex = this.colorProp
    }
  },
  methods: {
    async hex2name(hex) {
      return this.colors[hex] //|| (await axios.get('https://www.thecolorapi.com/id?format=json&named=true&hex=' + hex.substr(1))).data.name.value
    },
    randomColor() {
      return Object.keys(this.colors)[Math.floor(Math.random() * Object.keys(this.colors).length)]
    },
  },
}
</script>
